enum SignUpMethod {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
}

export default SignUpMethod;
